// surveyData.js
export const sections = [
  {
    title: "Compliance & Training",
    questions: [
      {
        id: "q1",
        text: "How well do you understand and follow the company's Standard Operating Procedures (SOPs)?",
        type: "rating"
      },
      {
        id: "q2",
        text: "How adequate was the training you received for handling prescriptions and patient data securely?",
        type: "rating"
      },
      {
        id: "q3",
        text: "How confident are you about GDPR and data protection compliance?",
        type: "rating"
      },
      {
        id: "q4",
        text: "How confident are you in knowing how to report a dispensing error or near-miss?",
        type: "rating"
      },
      {
        id: "q5",
        text: "How fully have you completed mandatory training modules in the last 12 months?",
        type: "rating"
      }
    ]
  },
  {
    title: "Career Development",
    questions: [
      {
        id: "q6",
        text: "How well does your current role align with your long-term career goals?",
        type: "rating"
      },
      {
        id: "q7",
        text: "How sufficient are the opportunities you are given to learn and develop your skills at work?",
        type: "rating"
      },
      {
        id: "q8",
        text: "How supportive is your manager of your career goals and development?",
        type: "rating"
      },
      {
        id: "q9",
        text: "What learning and development opportunities would you like the organization to offer to support your career goals?",
        type: "text"
      }
    ]
  },
  {
    title: "Patient Safety & Service",
    questions: [
      {
        id: "q10",
        text: "How strongly do you believe the pharmacy maintains high standards for patient safety?",
        type: "rating"
      },
      {
        id: "q11",
        text: "How well are prescriptions checked and dispensed in line with regulations?",
        type: "rating"
      },
      {
        id: "q12",
        text: "How supported do you feel in raising concerns about patient care or safety?",
        type: "rating"
      },
      {
        id: "q13",
        text: "How clear and effective do you think communication with patients/customers is?",
        type: "rating"
      }
    ]
  },
  {
    title: "Workplace & Culture",
    questions: [
      {
        id: "q14",
        text: "How supported do you feel by your manager and colleagues?",
        type: "rating"
      },
      {
        id: "q15",
        text: "How manageable and fairly distributed do you find the workload?",
        type: "rating"
      },
      {
        id: "q16",
        text: "How encouraged do you feel to contribute ideas for improvement?",
        type: "rating"
      },
      {
        id: "q17",
        text: "How inclusive and respectful do you feel the workplace is?",
        type: "rating"
      }
    ]
  },
  {
    title: "Employee Experience",
    questions: [
      {
        id: "q18",
        text: "How would you rate the onboarding experience when you first joined?",
        type: "rating"
      },
      {
        id: "q19",
        text: "Do you feel you have the resources you need to succeed in your role?",
        type: "rating"
      },
      {
        id: "q20",
        text: "Do you feel your contributions make a difference?",
        type: "rating"
      },
      {
        id: "q21",
        text: "How well connected do you feel to your team on both a professional and personal level?",
        type: "rating"
      },
      {
        id: "q22",
        text: "Would you recommend this company to others based on your experience?",
        type: "yesno"
      }
    ]
  },
  {
    title: "Employee Well-being",
    questions: [
      {
        id: "q23",
        text: "How well do you feel the company supports your mental health needs?",
        type: "rating"
      },
      {
        id: "q24",
        text: "How often do you feel stressed at work?",
        type: "rating"
      },
      {
        id: "q25",
        text: "How comfortable do you feel to discuss well-being challenges with your manager?",
        type: "rating"
      },
      {
        id: "q26",
        text: "Would you recommend this company to others based on its focus on well-being?",
        type: "yesno"
      }
    ]
  },
  {
    title: "Leadership & Management",
    questions: [
      {
        id: "q27",
        text: "How comfortable do you feel expressing opinions and giving honest feedback to your managers?",
        type: "rating"
      },
      {
        id: "q28",
        text: "How well does your manager communicate expectations to you?",
        type: "rating"
      },
      {
        id: "q29",
        text: "How actionable and constructive is the feedback you receive from your managers?",
        type: "rating"
      },
            {
        id: "q30",
        text: "How well does leadership encourage employees to prioritise well-being?",
        type: "rating"
      },
      {
        id: "q31",
        text: "What would you like to see leadership and management do differently, and why?",
        type: "text"
      }
    ]
  },
  {
    title: "Open Feedback",
    questions: [
      {
        id: "q32",
        text: "What would you deem the most important quality any employer may look for in an employee?",
        type: "text"
      },
      {
        id: "q33",
        text: "Please provide any additional comments, concerns, or suggestions for improving our services and working environment:",
        type: "text"
      }
    ]
  }
];